import { IPersonBadge } from "../../types";
import { BadgeStatuses } from "../../enums";
import { PING_URL } from "../../pingUrl";

const isNetworkReachable = () => {
  return fetch(PING_URL, { method: "GET", mode: "no-cors" })
    .then(resp => resp && (resp.ok || resp.type === "opaque"))
    .catch(() => false);
};

const isBadgeValid = (badge: IPersonBadge) => {
  const { contact, customerType, qrCodeContent, productCode, organisation, status } = badge;
  return Boolean(
    contact &&
      contact.firstName &&
      contact.lastName &&
      customerType &&
      qrCodeContent &&
      productCode &&
      organisation &&
      organisation.displayName &&
      status !== BadgeStatuses.CREATED
  );
};

const isNotCancelled = (status?: string | null): boolean => {
  if (status) {
    return status.toLowerCase() !== (BadgeStatuses.CANCELLED).toLowerCase();
  }
  return false;
};

const Utils = {
  isNetworkReachable,
  isBadgeValid,
  isNotCancelled
};

export default Utils;
